/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvoiceDataV1Dto } from './InvoiceDataV1Dto';
import type { ObjectionPositionReductionV1Dto } from './ObjectionPositionReductionV1Dto';
import type { OperatingCostInvoiceLineItemV1Dto } from './OperatingCostInvoiceLineItemV1Dto';
export type ObjectionPositionV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Comment specific to this line item within the objection
   */
  comment?: string;
  status?: ObjectionPositionV1Dto.status;
  /**
   * UUID of the Objection
   */
  objectionId: string;
  /**
   * UUID of the OperatingCostInvoiceLineItem
   */
  lineItem: OperatingCostInvoiceLineItemV1Dto;
  /**
   * Invoice data (PointOfSale, Contract, and dates)
   */
  invoice: InvoiceDataV1Dto;
  /**
   * The green reduction contribution
   */
  reductionGreen?: ObjectionPositionReductionV1Dto;
  /**
   * The yellow reduction contribution
   */
  reductionYellow?: ObjectionPositionReductionV1Dto;
  /**
   * The red reduction contribution
   */
  reductionRed?: ObjectionPositionReductionV1Dto;
};
export namespace ObjectionPositionV1Dto {
  export enum status {
    UNCLEAR = 'Unclear',
    IN_CLARIFICATION = 'InClarification',
    CLARIFIED = 'Clarified',
  }
}
